<template>
  <div
    class="absolute left-0 z-10 w-full bg-primary-purple flex flex-col"
    style="top: 45px; height: calc(100vh - 45px)">
    <div v-if="!isLoggedIn || onTrial" class="mt-4 flex w-full account-links">
      <a
        v-if="!isLoggedIn"
        href="/pricing/"
        class="flex-1 account-link account-link--primary mr-3"
        @click.prevent="clickOnFreeTrial('Start Free Now')">
        Start Free Now
      </a>
      <a
        v-if="$store.getters.hasContinuityPlan"
        href="/account/subscription/"
        class="w-full account-link account-link--primary">
        Upgrade
      </a>
      <a
        v-else-if="onTrial"
        href="/pricing/"
        class="w-full account-link account-link--primary"
        @click="
          eventTracker(analyticsEvents.clickOnGetALicense, {
            source: 'top nav',
            button_name: 'Get a license',
          })
        ">
        Get a License
      </a>
      <a
        v-else-if="$store.getters.userType !== 'paid'"
        href="/pricing/"
        class="account-link account-link--outline flex-1 font-artlist-sans-bold"
        @click="closeMenuAndTrackPricingClickEvents">
        Pricing
      </a>
    </div>
    <div class="flex-1 overflow-auto">
      <div v-if="!activeSection" class="pt-2 flex flex-col">
        <div class="subcat">categories</div>

        <button
          type="button"
          class="drawer-link"
          @click="openSubcategory('templates')"
          v-event-track:myAccountArea.menuItemChosen="{ menu: 'drawer', item: 'templates' }">
          <div class="drawer-link__content">
            <div>Templates</div>
            <SvgIcon icon="chevron-right" class="inline-flex" />
          </div>
        </button>

        <button
          type="button"
          class="drawer-link"
          @click="openSubcategory('presets')"
          v-event-track:myAccountArea.menuItemChosen="{ menu: 'drawer', item: 'presets' }">
          <div class="drawer-link__content">
            <div>Presets</div>
            <SvgIcon icon="chevron-right" class="inline-flex" />
          </div>
        </button>

        <a
          href="/browse/luts/"
          class="drawer-link"
          @click="clickOnCategory('luts')"
          v-event-track:myAccountArea.menuItemChosen="{ menu: 'drawer', item: 'luts' }"
          @mouseover="$emit('hovered', 'luts')">
          <div class="drawer-link__content">
            <div class="flex items-center">
              LUTs
            </div>
            <SvgIcon icon="chevron-right" class="inline-flex" />
          </div>
        </a>

        <a
          href="/browse/voice-over/"
          class="drawer-link"
          @click="clickOnCategory('voiceover')"
          v-event-track:myAccountArea.menuItemChosen="{ menu: 'drawer', item: 'voiceover' }"
          @mouseover="$emit('hovered', 'voiceover')">
          <div class="drawer-link__content">
            <div class="flex items-center">
              <img src="/assets/images/shared/stars.png" class="mr-[6px]" />
              Voiceover
            </div>
            <SvgIcon icon="chevron-right" class="inline-flex" />
          </div>
        </a>

        <button
          type="button"
          class="drawer-link"
          @click="openSubcategory('audio')"
          v-event-track:myAccountArea.menuItemChosen="{ menu: 'drawer', item: 'audio' }">
          <div class="drawer-link__content">
            <div>Audio</div>
            <SvgIcon icon="chevron-right" class="inline-flex" />
          </div>
        </button>

        <button
          type="button"
          class="drawer-link"
          @click="openSubcategory('videos')"
          v-event-track:myAccountArea.menuItemChosen="{ menu: 'drawer', item: 'videos' }">
          <div class="drawer-link__content">
            <div>Videos</div>
            <SvgIcon icon="chevron-right" class="inline-flex" />
          </div>
        </button>

        <button
          type="button"
          class="drawer-link"
          @click="openSubcategory('images')"
          v-event-track:myAccountArea.menuItemChosen="{ menu: 'drawer', item: 'images' }">
          <div class="drawer-link__content">
            <div>Images</div>
            <SvgIcon icon="chevron-right" class="inline-flex" />
          </div>
        </button>

        <div class="subcat">more</div>

        <a
          href="/plugins/"
          class="drawer-link"
          @click="clickOnCategory('plugins')"
          v-event-track:myAccountArea.menuItemChosen="{ menu: 'drawer', item: 'plugins' }">
          <div class="drawer-link__content">
            <div class="flex items-center">
              <div>Plugins</div>
            </div>
            <SvgIcon icon="chevron-right" class="inline-flex" />
          </div>
        </a>

        <button
          type="button"
          class="drawer-link"
          @click="openSubcategory('tools')"
          v-event-track:myAccountArea.menuItemChosen="{ menu: 'drawer', item: 'tools' }">
          <div class="drawer-link__content">
            <div>Tools</div>
            <SvgIcon icon="chevron-right" class="inline-flex" />
          </div>
        </button>
      </div>

      <a
        v-if="!activeSection"
        href="/learn/"
        target="_blank"
        class="drawer-link"
        @click="clickOnCategory('learn')"
        v-event-track:myAccountArea.menuItemChosen="{ menu: 'drawer', item: 'learn' }">
        <div class="drawer-link__content">
          <div>Learn</div>
          <SvgIcon icon="chevron-right" class="inline-flex" />
        </div>
      </a>

      <a
        v-if="!isLoggedIn"
        href="/account/login/"
        class="drawer-link"
        @click.prevent="openSignInModal">
        <div class="drawer-link__content">Sign In</div>
      </a>

      <a
        v-if="isLoggedIn"
        href="/account/logout/"
        class="drawer-link"
        v-event-track:myAccountArea.menuItemChosen="{ menu: 'drawer', item: 'log out' }">
        <div class="drawer-link__content">
          <div>Log Out</div>
        </div>
      </a>

      <div v-if="activeSection">
        <button
          type="button"
          class="capitalize text-lg mx-3 my-5 p-0 selected-category"
          @click="closeCategory">
          <i class="fa fa-chevron-left nav-arrow mr-2" />
          {{ activeSection }}
        </button>
        <a
          v-for="{ text, link, icon } in subcategoriesLinks"
          :key="text"
          slot="link"
          :href="link"
          @click="clickOnSubcategory(text)">
          <div class="drawer-link__content drawer-link">
            <div v-html="icon" class="subcategory-icon mr-1" />
            <div class="ml-2 mr-auto">{{ text }}</div>
            <SvgIcon icon="chevron-right" class="inline-flex" />
          </div>
        </a>
      </div>
      <Footer class="mb-3" />
    </div>
  </div>
</template>

<script>
import generateCategories from '@/utilities/category-links';
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';
import Footer from './footer';
import SvgIcon from '@/components/SvgIcon';

export default {
  components: {
    Footer,
    SvgIcon,
  },
  data: () => ({
    activeSection: '',
    eventTracker,
    analyticsEvents,
  }),
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    onTrial() {
      return this.$store.getters.userType === 'free';
    },

    subcategoriesLinks() {
      const currentCategory = this.activeSection;
      return generateCategories()[currentCategory];
    },
  },
  methods: {
    openSubcategory(sectionName) {
      this.activeSection = sectionName;
      eventTracker(analyticsEvents.clickOnCategory, {
        categoryName: sectionName,
        clickSource: 'drawer',
      });
    },

    clickOnCategory(sectionName) {
      eventTracker(analyticsEvents.clickOnCategory, {
        categoryName: sectionName,
        clickSource: 'drawer',
      });
    },

    closeCategory() {
      this.activeSection = '';
    },

    clickOnSubcategory(name) {
      eventTracker(analyticsEvents.clickOnSubcategory, {
        subCategoryName: name,
        clickSource: 'drawer',
      });
    },

    clickOnFreeTrial(buttonName) {
      this.$emit('close');
      this.$store.dispatch('setOpenSignUpModal', {
        open: true,
        clickSource: 'main navigation',
        buttonName,
      });
      eventTracker(analyticsEvents.clickStartFreeTrial, {
        source: 'drawer',
        button_name: buttonName,
      });
    },
    openSignInModal() {
      this.$emit('close');
      this.$store.dispatch('setOpenSignInModal', {
        open: true,
        clickSource: 'main navigation',
        buttonName: 'Sign In',
      });

      this.trackSignInClickEvents();
    },
    closeMenuAndTrackPricingClickEvents() {
      this.$emit('close');
      this.trackPricingClickEvents();
    },
    trackSignInClickEvents() {
      eventTracker(analyticsEvents.clickOnCategory, {
        categoryName: 'sign in',
        clickSource: 'drawer',
      });
      eventTracker(analyticsEvents.navigationClick, {
        clickUrl: 'sign in popup',
        type: 'menu',
      });
      eventTracker(analyticsEvents.myAccountArea.menuItemChosen, {
        menu: 'drawer',
        item: 'sign in',
      });
    },
    trackPricingClickEvents() {
      eventTracker(analyticsEvents.clickOnCategory, {
        categoryName: 'pricing',
        clickSource: 'drawer',
      });
      eventTracker(analyticsEvents.navigationClick, {
        clickUrl: '/pricing/',
        type: 'menu',
      });
      eventTracker(analyticsEvents.myAccountArea.menuItemChosen, {
        menu: 'drawer',
        item: 'pricing',
      });
      eventTracker(analyticsEvents.clickPricing, {
        clickSource: 'drawer CTA',
      });
    },
  },
};
</script>

<style>
.nav-arrow {
  font-size: 14px;
  @apply text-primary-beige;
}

.subcat {
  margin: 22px 16px 12px;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 16px;
  @apply text-white;
}

.account-links {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 10px;
}

.account-link {
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 16px;
  font-weight: 700;

  border-radius: 4px;
}

.drawer-link {
  display: block;
  padding-left: 16px;
  padding-right: 16px;
  cursor: pointer;
}

.drawer-link__content {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-size: 18px;
  @apply mx-0 border-b border-p40 text-p40;
}

.subcategory-icon {
  display: flex;
  align-items: center;
}

.subcategory-icon > svg > path:first-child {
  fill: #b2b2b2;
}

.subcategory-icon > svg > path:last-child {
  fill: #fff;
}

.selected-category {
  color: #666666;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.account-link--outline {
  @apply border border-solid border-primary-offwhite text-primary-offwhite;
}
.account-link--outline:hover {
  @apply text-primary-offwhite;
}

.account-link--primary {
  @apply bg-primary-green text-primary-purple;
}

.account-link--primary:hover {
  @apply bg-primary-green-hover text-primary-purple;
}
.text-\[10px\] {
  font-size: 10px;
}
.py-\[2px\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.mr-\[6px\] {
  margin-right: 6px;
}
.px-\[4px\] {
  padding-right: 4px;
  padding-left: 4px;
}
</style>
